import CustomSelect from '../../../components/CustomSelect';
import MutipleSelection from '../../../components/CustomSelect/MutipleSelection';
import TableContainer from '../../../components/Table/TableContainer';
import { QueueStatus, QueueColor } from '../../../enum/QueueEnum';
import { handleSelectAll, momentFormatted } from '../../../helpers';
import TableCellFilted from '../../common/componentUI/TableCellFilted';
import { ChipStatus } from '../../common/componentUI/commonStyleComponents';
import doctorDispatcher from '../../doctor/action/doctor';
import caQueueDispatcher from '../action/caQueue';
import { CheckboxActive, CheckboxDefault } from '@/assets/svg';
import CustomAsyncAutoComplete from '@/new-components/CustomAsyncAutoComplete';
import CustomDate from '@/new-components/CustomDate';
import CustomSelectContainer from '@/new-components/CustomSelectOld/CustomSelectContainer';
import {
  TableHead,
  TableRow,
  TableCell,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  Checkbox,
  Paper,
  Box,
  TextField,
  withStyles,
  makeStyles,
  Grid,
} from '@material-ui/core';
import {
  MoreVertRounded,
  ArtTrackOutlined,
  CancelRounded,
} from '@material-ui/icons';
import { sortBy } from 'lodash';
import { startCase, isEmpty } from 'lodash';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const CustomFilterInput = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      height: '40px !important',
      borderRadius: 8,

      '& input': {
        padding: 0,
        marginLeft: 0,
      },
      '& input::placeholder': {
        opacity: 1,
        color: '#999999',
      },
    },
  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  isBtnSelected: {
    border: 'none',
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
  },
  checkboxIcon: {
    padding: 0,
    marginRight: 4,
  },
  tagStyle: {
    maxWidth: 'calc(100% - 60px)', // Adjust based on your needs
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  selectWrapper: {
    '& .MuiIconButton-root:hover': {
      backgroundColor: 'transparent',
    },

    '& .MuiAutocomplete-option': {
      padding: 8,
      borderRadius: 8,
      margin: '2px 8px',
      '&:first-child': {
        marginTop: 8,
      },
      '&:last-child': {
        marginBottom: 8,
      },
      '&.MuiAutocomplete-option[aria-selected="true"]': {
        backgroundColor: '#ffffff',
      },
    },
  },
}));

const CAQueue = () => {
  const classes = useStyles();
  const data = useSelector((state) => state.caQueue.list);
  const [selectedItem, setSelectedItem] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [statusOpen, setStatusOpen] = useState(false);
  const [statusFilter, setStatusFilter] = useState([]);
  const [searchKey, setSearchKey] = useState('');
  const [filterOption, setFilterOption] = useState({
    fromDate: moment().startOf('date'),
    toDate: moment().endOf('date'),
  });
  const [hiddenRows, setHiddenRows] = useState({});
  const [clinicOpen, setClinicOpen] = useState(false);
  const [clinicFilter, setClinicFilter] = useState([]);
  const [startDate, setStartDate] = useState(moment().startOf('date'));

  const listClinic = useSelector((state) =>
    sortBy(
      (state.doctor.clinics.list || []).map((i) => ({
        key: i.id,
        value: i.name,
      })),
      (item) => item.value.toLowerCase()
    )
  );

  const onChangeStartDate = (value) => {
    setStartDate(value || '');
    setFilterOption({
      ...filterOption,
      fromDate: moment(value).startOf('date'),
      toDate: moment(value).endOf('date'),
    });
  };
  const TableCellFiltedWrapper = ({ ...props }) => (
    <TableCellFilted
      {...{
        hiddenRows,
        setHiddenRows,
      }}
      {...props}
    />
  );

  const Header = () => (
    <TableHead>
      <TableRow>
        <TableCellFiltedWrapper
          style={{ paddingLeft: 20 }}
          label="Date"
          stateValue="creationTime"
        />
        <TableCellFiltedWrapper label="Clinic" stateValue="clinicName" />
        {/* <TableCellFiltedWrapper label="Address" stateValue="clinicAddress" /> */}
        <TableCellFiltedWrapper label="Patient" stateValue="patientFullName" />
        <TableCellFiltedWrapper label="Queue Number" stateValue="queueNo" />
        {/* <TableCellFiltedWrapper
          label="Estimated Wait Time"
          stateValue="estimatedTime"
        /> */}
        <TableCellFiltedWrapper label="Status" stateValue="status" />
        {/* <TableCellFiltedWrapper label="Status Name" stateValue="statusName" /> */}
        <TableCell></TableCell>
      </TableRow>
    </TableHead>
  );

  useEffect(() => {
    doctorDispatcher.getClinics();
    return () => {};
  }, []);

  const handleClick = (item) => (event) => {
    setSelectedItem(item);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const renderMenuItem = () => {
    if (!selectedItem) return [];
    let options = [];
    if (selectedItem.queueRequestStatus === QueueStatus.Accepted) {
      options = [
        {
          key: 'cancel',
          icon: CancelRounded,
          label: 'Cancel Queue Request',
          onClick: () => {
            caQueueDispatcher.rejectQueue(
              selectedItem.id,
              searchKey,
              filterOption
            );
            handleClose();
          },
        },
      ];
    }
    return options.map((d) => {
      let Icon = d.icon;
      return (
        <MenuItem
          key={d.key}
          style={{
            display: 'flex',
            alignItems: 'center',
            fontFamily: 'Source Sans Pro',
            color: '#192637',
          }}
          onClick={d.onClick}
        >
          <ListItemIcon style={{ minWidth: 34 }}>
            <Icon style={{ color: '#CACFD3' }} />
          </ListItemIcon>
          {d.label}
        </MenuItem>
      );
    });
  };

  const renderValue = (array, label, defaultLabel) => {
    let value = '';
    if (array.length === 0) value = defaultLabel;
    else if (array.length === 1) value = array[0];
    else value = `${label} (${array.length})`;

    return value;
  };

  return (
    <>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {renderMenuItem()}
      </Menu>
      <TableContainer
        title="Queue Requests"
        query={caQueueDispatcher.getData}
        header={Header}
        data={data}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        filterOption={filterOption}
        ToolbarComponent={
          <>
            <Grid container spacing={4} style={{ margin: '6px 0px 0px' }}>
              <Grid item xs={12} md={4}>
                <CustomDate
                  selectedDate={startDate}
                  isFullWidth
                  placeholder={startDate ? `${startDate}` : 'Date'}
                  clearable
                  onChange={onChangeStartDate}
                  onClear={() => {
                    setStartDate('');
                    setFilterOption({
                      ...filterOption,
                      fromDate: '',
                      toDate: '',
                    });
                  }}
                  style={{ height: 40 }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomAsyncAutoComplete
                  multiple
                  disableCloseOnSelect
                  isLocation
                  endpoint="clinics/filter"
                  method="post"
                  nameKey="name"
                  value={clinicFilter}
                  onChange={(e, value) => {
                    setFilterOption({
                      ...filterOption,
                      clinicIds: value.map((it) => it.id),
                    });
                    setClinicFilter(value);
                  }}
                  getOptionLabel={(option) => option?.name}
                  renderInput={(params) => (
                    <CustomFilterInput
                      {...params}
                      variant="outlined"
                      placeholder={isEmpty(clinicFilter) ? 'All clinics' : ''}
                    />
                  )}
                  renderOption={(option, { selected }) => {
                    return (
                      <Box display="flex" gridGap={4}>
                        <Checkbox
                          icon={<CheckboxDefault width={20} height={20} />}
                          checkedIcon={
                            <CheckboxActive width={20} height={20} />
                          }
                          checked={selected}
                          color="primry"
                          className={classes.checkboxIcon}
                        />
                        <span>{option.name}</span>
                      </Box>
                    );
                  }}
                  renderTags={(value, getTagProps) => {
                    let newValue = value.filter((it) =>
                      clinicFilter?.includes(it)
                    );
                    return newValue.length === 1 ? (
                      <div className={classes.tagStyle}>{newValue[0].name}</div>
                    ) : newValue.length > 1 ? (
                      <Box>Clinics ({newValue.length})</Box>
                    ) : (
                      ''
                    );
                  }}
                  PaperComponent={({ children, ...other }) => (
                    <Paper
                      {...other}
                      style={{ width: 320 }}
                      className={classes.selectWrapper}
                    >
                      {children}
                    </Paper>
                  )}
                  style={{
                    height: 40,
                  }}
                  isSelected={clinicFilter.length === 1}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomSelectContainer
                  isFullWidth
                  height="40px"
                  filterValue={statusFilter || []}
                  data={QueueStatus}
                  renderValue={renderValue(
                    statusFilter,
                    'Statuses',
                    'All statuses'
                  )}
                  onClear={() => {
                    setStatusFilter([]);
                    setFilterOption({
                      ...filterOption,
                      queueRequestStatuses: [],
                    });
                  }}
                  onChange={(e) => {
                    const value = handleSelectAll(
                      e.target.value,
                      QueueStatus.map((item) => item.value),
                      statusFilter
                    );
                    setFilterOption({
                      ...filterOption,
                      queueRequestStatuses: value,
                    });
                    setStatusFilter(value);
                  }}
                  labelSelectAll={'All statuses'}
                  useSelectAll
                  checkedAll={
                    QueueStatus.map((item) => item.value).length ===
                    statusFilter.length
                  }
                />
              </Grid>
            </Grid>

            {/* <CustomSelect
              onClick={() => {
                setStatusOpen(!statusOpen);
              }}
              clearable={!isEmpty(statusFilter)}
              onClear={() => {
                setStatusFilter([]);
                setFilterOption({
                  ...filterOption,
                  queueRequestStatuses: [],
                });
              }}
              prefixIcon={
                <ArtTrackOutlined
                  style={{
                    fontSize: 20,
                    color: '#E9E9E9',
                    marginRight: 8,
                  }}
                />
              }
              renderValue={<>{statusFilter.join(', ') || 'Select Status'}</>}
            >
              <MutipleSelection
                value={statusFilter}
                data={QueueStatus}
                open={statusOpen}
                onChange={(e) => {
                  setFilterOption({
                    ...filterOption,
                    queueRequestStatuses: e.target.value,
                  });
                  setStatusFilter(e.target.value);
                }}
              />
            </CustomSelect> */}
          </>
        }
        renderRow={(d) => (
          <>
            <TableCell
              style={{
                paddingLeft: 20,
              }}
            >
              {!hiddenRows.creationTime &&
                momentFormatted(d.creationTime, ' hh:mm DD MMM, YYYY')}
            </TableCell>
            <TableCell>{!hiddenRows.clinicName && d.clinicName}</TableCell>
            {/* <TableCell>
              {!hiddenRows.clinicAddress && d.clinicAddress}
            </TableCell> */}
            <TableCell>
              {!hiddenRows.patientFullName && d.patientFullName}
            </TableCell>
            <TableCell>{!hiddenRows.queueNo && d.queueNo}</TableCell>
            {/* <TableCell>
              {!hiddenRows.estimatedTime && d.estimatedTime}
            </TableCell> */}
            <TableCell>
              {!hiddenRows.status && (
                <ChipStatus color={QueueColor[d.queueRequestStatus]}>
                  {startCase(d.queueRequestStatus)}
                </ChipStatus>
              )}
            </TableCell>
            {/* <TableCell>{!hiddenRows.statusName && d.statusName}</TableCell> */}
            <TableCell align="right">
              {d.queueRequestStatus === QueueStatus.Accepted && (
                <IconButton onClick={handleClick(d)}>
                  <MoreVertRounded />
                </IconButton>
              )}
            </TableCell>
          </>
        )}
      />
    </>
  );
};

export default CAQueue;
